import { z } from 'zod';

export const CHECK_USER_RESPONSE_SCHEMA = z.object({
  permissions: z.array(z.object({ permission: z.string() })),
});

export type CheckUserResponse = z.infer<typeof CHECK_USER_RESPONSE_SCHEMA>;
